import { lazy } from 'react';
import Loadable from '../components/Loadable';
import AuthLayout from '../layouts/AuthLayout';
import MarketWrapper from '../plugins/Market/pages/MarketWrapper';


const DashboardPage = Loadable(()=>import('../pages/dashboard/DashboardPage'));
const UsersPage = Loadable(()=>import('../pages/users/UsersPage'));
const IndexPage = Loadable(()=>import('../pages/index/IndexPage'));
const ProfilePage = Loadable(()=>import('../pages/profile/ProfilePage'));
const SettingsPage = Loadable(()=>import('../pages/settings/SettingsPage'));
const SitePagesPage = Loadable(()=>import('../pages/sitePages/SitePagesPage'));
const SiteBlogPage = Loadable(()=>import('../pages/siteBlog/SiteBlogPage'));
const PageBlock = Loadable(()=>import('../pages/sitePageBlock/PageBlock'));
const PostContent = Loadable(()=>import('../pages/postContent/PostContentPage'));

const MarketCategory = Loadable(()=>import('../plugins/Market/pages/MarketCategoryPage'));
const MarketCategories = Loadable(()=>import('../plugins/Market/pages/MarketCategoriesPage'));
const MarketProducts = Loadable(()=>import('../plugins/Market/pages/MarketProductsPage'));
const MarketProduct = Loadable(()=>import('../plugins/Market/pages/MarketProductPage'));
const MarketOrders = Loadable(()=>import('../plugins/Market/pages/MarketOrdersPage'));

   
const MainRoutes = {
    path: '/',
    element: <AuthLayout/>,  
    children: [
        {
            path: '/',
            element: <IndexPage/>
        },
        {
            path: '/users',
            element: <UsersPage/>
        }, 
        {
            path: '/dashboard',
            element: <DashboardPage/>
        },
        {
            path: '/settings',
            element: <SettingsPage/>
        },
        {
            path: '/pages',
            element: <SitePagesPage/>
        },
        {
            path: '/pages/block/:blockId',
            element: <PageBlock/>
        },
        {
            path: '/blog',
            element: <SiteBlogPage/>
        },
        {
            path: '/blog/post/:postId',
            element: <PostContent/>
        },
        {
            path: '/profile',
            element: <ProfilePage/>
        },

        {
     

        path: '/market',
        element : <MarketWrapper/>,
        children:[
            // MARKET 
            {
                path: 'categories',
                element: <MarketCategories/>
            },
            {
                path: 'category/:categoryId',
                element: <MarketCategory/>
            },
            {
                path: 'products',
                element: <MarketProducts/>
            },
            {
                path: 'products/category/:categoryId',
                element: <MarketProducts/>
            },            
            {
                path: 'product/:productId',
                element: <MarketProduct/>
            },

            {
                path: 'orders',
                element: <MarketOrders/>
            }
        ]

        }

    ]
}

export default MainRoutes;